module.exports = __webpack_public_path__ + "img/US_BonusDamagevsShip_ua.97c23533.webp";